import { render, staticRenderFns } from "./MyGender.vue?vue&type=template&id=ed4d1d7e&scoped=true"
import script from "./MyGender.vue?vue&type=script&lang=js"
export * from "./MyGender.vue?vue&type=script&lang=js"
import style0 from "./MyGender.vue?vue&type=style&index=0&id=ed4d1d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4d1d7e",
  null
  
)

export default component.exports